/**
 * ═════════════════════════════════════════════════════════════════════════════════════════════
 * ЧЕЛОВЕК ВВОДИТ РУБЛИ. КОНТРАКТ ПРИНИМАЕТ КОПЕЙКИ. УМНОЖЕНИЕ ЖИВЁТ ЗДЕСЬ
 * ═════════════════════════════════════════════════════════════════════════════════════════════
 *
 * Любое целочисленное денежное поле контракта — в копейках (правило в начале `common.yaml`).
 * **Ошибка тут тихая и ровно в сто раз**: обе величины `number`, ни `tsc`, ни линт её не увидят.
 * Поэтому перевод один на приложение, у него есть имя и он закрыт тестом.
 *
 * Разбор ВВОДА тоже здесь, но не весь: форма новой брони парсит по-своему (только целые рубли, как
 * в макете) и держит это у себя, а денежные поля, которым нужны копейки после запятой, берут общий
 * `rubleInputToAmount` — их уже двое (сумма шага сценария и «назвать сумму» в карточке брони), и
 * третья копия разъехалась бы ровно так, как описано выше.
 */

const KOPECKS_IN_RUBLE = 100

/**
 * Рубли → копейки. Округляем: `50.5 * 100` в двоичной плавающей даёт `5050.000000000001`, а
 * копейки целые.
 */
export function rublesToKopecks(rubles: number): number {
  return Math.round(rubles * KOPECKS_IN_RUBLE)
}

/** Копейки → рубли. Обратная сторона того же перевода. */
export function kopecksToRubles(kopecks: number): number {
  return kopecks / KOPECKS_IN_RUBLE
}

/**
 * Значение денежного поля ввода: наружу рубли строкой, внутрь копейки. Держится рядом с самим
 * переводом, потому что потребителей больше одного — сумма шага сценария и «назвать сумму» в
 * карточке брони, — а разошедшиеся копии парсинга ошибаются молча и ровно в сто раз.
 */
export function amountToRubleInput(value: number | undefined): string {
  return value == null ? '' : String(kopecksToRubles(value))
}

export function rubleInputToAmount(input: string): number | undefined {
  /*
   * Запятая как десятичный разделитель: на русской раскладке её набирают чаще точки, а `Number`
   * читает «50,5» как NaN — поле молча очищалось бы под курсором.
   *
   * ⚠️ ПРОБЕЛЫ ВЫКИДЫВАЮТСЯ ВСЕ, А НЕ ТОЛЬКО ПО КРАЯМ. Одного `trim()` мало: «5 000» — запись,
   * которой человека никто не отучал, а мы сами печатаем её во всех суммах, — даст `NaN` →
   * `undefined`. В окне записи платежа это гасит кнопку «Записать» БЕЗ ОБЪЯСНЕНИЯ: ошибки нет,
   * подсказки нет, кнопка мертва. Соседняя форма создания брони пробелы выкидывает
   * (`features/booking-create/model/money.ts`), то есть две денежные формы приложения принимали
   * разный ввод. `\s` покрывает и неразрывный пробел с узким неразрывным — именно ими разделяет
   * разряды `Intl`, и они попадают в поле копированием из соседней строки.
   */
  const normalized = input.replace(/\s/g, '').replace(',', '.')
  if (normalized === '') return undefined
  const parsed = Number(normalized)
  // Минус в сумме не значит ничего, а сервер принял бы его молча.
  if (!Number.isFinite(parsed) || parsed < 0) return undefined
  return rublesToKopecks(parsed)
}
